let configCache = null;

export const getConfig = async () => {
  if (configCache) return configCache;

  const response = await fetch("/config.json");
  if (!response.ok) throw new Error("Cannot load config.json from public folder");
  configCache = await response.json();
  return configCache;
};

export const getDatabaseKey = async () => {
  const config = await getConfig();
  return config.databasekey;
};

export const getApiBaseUrl = async () => {
  const config = await getConfig();
  return config.apiBaseUrl;
};

export const getAllowedUsers = async () => {
  const config = await getConfig();
  return config.allowedUsers;
};
